import React, { Component } from 'react'
import { DropdownToggle } from 'reactstrap';
import S3 from 'react-aws-s3';
import { Link } from "react-router-dom";


import {Col, Card, CardBody, CustomInput, Dropdown, Modal, ModalHeader, ModalBody, Input, Button, Label, FormGroup, Alert} from "reactstrap"
import FilePreviewerThumbnail from 'react-file-previewer';
import { victimDocumentUrl } from '../../helpers/url';



export default class DocumentAdd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            success: false,
            successMessage: "",
            menu : false,
            modal_center: false,

            tempDocumentType: 1,
			tempDocumentId: 0,
			tempDocumentIdNumber: '',
			tempDocumentNotes: '',
			tempDocumentIssuedBy: '',
			tempDocumentIssuedDate: '',
			tempDocumentLocation: '',
        }
        this.tog_center = this.tog_center.bind(this);
    }

    tog_center() {
        this.setState(prevState => ({
          modal_center: !prevState.modal_center
        }));
    }

    fileSubmitToS3 = async (event) => {
		const config = {
			bucketName: process.env.REACT_APP_BUCKET_NAME,
			region: process.env.REACT_APP_REGION,
			accessKeyId: process.env.REACT_APP_ACCESS_KEY_ID,
			secretAccessKey: process.env.REACT_APP_SECRET_KEY_ID,
		};
		const ReactS3Client = new S3(config);
		await ReactS3Client.uploadFile(event.target.files[0], 'testimony/' + this.props.victimId + '/document/' + event.target.files[0].name)
			.then(data => {
				if (data && data.location) {
						this.setState({
							tempDocumentLocation: data.location,
						});
				}
			})
			.catch(err => {
				this.setState({
					error: true,
					errorMsg: err.message,
				});
			});
	};

    submit = () => {
		const session = JSON.parse(sessionStorage.getItem('authUser'));
		const accessToken = session.jwtToken;
        fetch(victimDocumentUrl, {
            method: "POST",
            headers: {"Content-Type": "application/json", "Authorization": accessToken},
            body: JSON.stringify([{
                type: parseInt(this.state.tempDocumentType),
                idNumber: this.state.tempDocumentIdNumber,
                s3location: this.state.tempDocumentLocation,
                notes: this.state.tempDocumentNotes,
                issuedBy: this.state.tempDocumentIssuedBy,
                issuedDate: this.state.tempDocumentIssuedDate === "" ? "1900-01-01T00:00:10Z" : (this.state.tempDocumentIssuedDate + 'T00:00:10Z'),
                victimId: this.props.victimId,
                documentId: this.state.tempDocumentId
            }])
        }).then(res=>res.json())
        .then(data => {
            this.setState({
                success: true,
                successMessage: "Submitted! Go back to Testimony Manager and come back again."
            })
        })
    }

    tempStateHandling = (event) => {
        let targetId = event.target.id;
		let targetValue = event.target.value;
		let targetType = event.target.type;
        console.log(targetId, targetValue, targetType)
		if (targetType === 'text' || targetType === "textarea") {
            this.setState({
                [targetId]: targetValue,
			});
        }
        else if (targetType === 'number' || targetType === 'select-one') {
			if (targetValue === isNaN) {
				targetValue = 0;
			}
			this.setState({
				[targetId]: parseInt(targetValue),
			});
        }
        else {
			this.setState({
				[event.target.id]: event.target.value,
			});
		}
    }


    render() {
        return (
            <React.Fragment>
                            <Dropdown className="float-right" isOpen={this.state.menu} toggle={() => this.setState({menu : !this.state.menu})}>
                                <DropdownToggle tag="i" className="darrow-none card-drop" aria-expanded="false">
                                    <Link><i className="mdi mdi-book-plus-multiple-outline" onClick={this.tog_center}></i></Link>

                                    <Modal size="lg" isOpen={this.state.modal_center} toggle={this.tog_center} centered={true} >
                                        <ModalHeader toggle={() => this.setState({ modal_center: false })}> Document - Add </ModalHeader>
                                        <ModalBody>
															<Card>
																<CardBody>
                                                                <div className="mt-5 text-center">
                                                                    <Alert color="success" isOpen={this.state.success} toggle={() => {this.setState({success:!this.state.success, successMessage: ""})}}>
                                                                        {this.state.successMessage}
                                                                    </Alert>
                                                                </div>
																	<FormGroup row>
																		<Label className="col-md-2 col-form-label">
																			Document Type
																		</Label>
																		<Col md={8}>
																			<select
																				className="custom-select"
																				id="tempDocumentType"
																				onChange={event => this.tempStateHandling(event)}
																				value={this.state.tempDocumentType}>
																				<option value="1">Passport</option>
																				<option value="2">National ID Card</option>
																				<option value="3">Other</option>
																			</select>
																		</Col>
																	</FormGroup>
																	<FormGroup row>
																		<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
																			Upload Document
																		</Label>
																		<Col md={8}>
																			<div className="custom-file mb-2">
																				<CustomInput
																					type="file"
																					className="custom-file-input"
																					id="tempDocumentFileHolder"
																					onChange={event => {
																						this.fileSubmitToS3(event);
																					}}
																				/>
																				<Label className="custom-file-label" htmlFor="tempDocumentFileHolder">
																					Choose file
																				</Label>
																			</div>
																		</Col>
																		<Col md={8}>
																			<div className="testimony-file-preview text-center">
																				{this.state.tempDocumentLocation !== '' ? (
																					<div>Uploaded</div>
																				) : (
																					//<Label htmlFor="example-text-input" className="col-md-2 col-form-label">{this.state.tempDocumentLocation.substr(this.state.tempDocumentLocation.length - 3)} Ready</Label>

																					''
																				)}
																			</div>
																		</Col>
																	</FormGroup>
																	<FormGroup row>
																		<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
																			ID Number
																		</Label>
																		<Col md={8}>
																			<Input
																				className="form-control"
																				type="text"
																				placeholder="Passport or National ID Number"
																				id="tempDocumentIdNumber"
																				onChange={event => this.tempStateHandling(event)}
																				value={this.state.tempDocumentIdNumber}
																			/>
																		</Col>
																	</FormGroup>
																	<FormGroup row>
																		<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
																			Issued By
																		</Label>
																		<Col md={8}>
																			<Input
																				className="form-control"
																				type="text"
																				placeholder="Document Issued By"
																				id="tempDocumentIssuedBy"
																				onChange={event => this.tempStateHandling(event)}
																				value={this.state.tempDocumentIssuedBy}
																			/>
																		</Col>
																	</FormGroup>
																	<FormGroup row>
																		<Label htmlFor="example-text-input" className="col-md-2 col-form-label">
																			Issued Date
																		</Label>
																		<Col md={8}>
																			<Input
																				type="date"
																				name="date"
																				id="tempDocumentIssuedDate"
																				placeholder="Date of this health situation"
																				onChange={event => this.tempStateHandling(event)}
																				value={this.state.tempDocumentIssuedDate}
																			/>
																		</Col>
																	</FormGroup>
																	<FormGroup row>
																		<Label htmlFor="example-text-input" md="2" className="form-label">
																			Notes
																		</Label>
																		<Col md={8}>
																			<textarea
																				className="form-control"
																				value={this.state.tempDocumentNotes}
																				id="tempDocumentNotes"
																				rows="2"
																				placeholder="Notes"
																				onChange={event => this.tempStateHandling(event)}
																			/>
																		</Col>
																	</FormGroup>
																	<FormGroup className="text-center">
																		<Button
																			color="primary"
																			type="button"
																			className="waves-effect waves-light me-1"
																			onClick={() => { this.submit() }}>
																			Submit <i className="ri-arrow-right-line align-middle ms-2"></i>
																		</Button>
																	</FormGroup>
                                                                </CardBody>
                                                            </Card>
                                        </ModalBody>
                                    </Modal>
                                </DropdownToggle>
                            </Dropdown>
            </React.Fragment>
        )
    }
}
